declare global {
  interface Navigator {
      msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}


export const extractmsisdn = (str: string) => {
  if (Array.isArray(str)) {
    return str.map((str: any) => str.value).map((data: any) => data.substring(data.indexOf(':') + 1, data.indexOf('@')))
  }
  return str.substring(str.indexOf(':') + 1, str.indexOf('@'))
}

export const xmlPayload = (pairedDevice: string, query: string) => {
  var pairedDeviceMsg=process.env.REACT_APP_PAIRED_DEVICE_MSG?process.env.REACT_APP_PAIRED_DEVICE_MSG:"msg.pc.t-mobile.com";
  return `<?xml version="1.0" encoding="UTF-8" ?>
  <multisim xmlns="http://www.t-mobile.com/xml/multisimref" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <unbarred-multisim-id>sip:${pairedDevice}@${pairedDeviceMsg}</unbarred-multisim-id>
    <barred-multisim-id-list>${query}</barred-multisim-id-list>
    <createTime>${new Date().toISOString()}</createTime><lastUpdateTime>${new Date().toISOString()}</lastUpdateTime>
  </multisim>`
}

